<template>
  <div>
    <subscription-table />
  </div>
</template>

<script>
import SubscriptionTable from "../components/subscriptionTable.vue";
export default {
  components: {
    "subscription-table": SubscriptionTable
  }
};
</script>

<style></style>
